<!-- Outer container -->
<div class="d-flex flex-column flex-nowrap vw-100 vh-100 overflow-x-hidden">
  <!-- Use the navbar component outside of scrollable area -->
  <app-navbar></app-navbar>
  <!-- Page content (scrollable) -->
  <main class="d-block flex-grow-1">
    <!-- After user loaded, show page -->
    <ng-container *ngIf="user$ | async; else showLoadingSpinner">
      <!-- Show current page -->
      <router-outlet></router-outlet>
    </ng-container>
    <!-- Before user loaded, show spinners -->
    <ng-template #showLoadingSpinner>
      <!-- Otherwise -->
      <div class="d-flex w-100 h-100 flex-row flex-wrap align-items-center justify-content-center">
        <!-- Show loading animation (three times) -->
        <div class="spinner-grow text-primary delay-1 slow me-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="spinner-grow text-primary delay-2 slow me-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="spinner-grow text-primary delay-3 slow me-0" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </ng-template>
  </main>
  <app-small-footer></app-small-footer>
</div>
